export default "/images/1d6f0cebb61091bda1c3360f1c403afd.avif";